<template>
  <component :is="page"></component>
</template>

<script>
export default {
  name: 'ProductDistributorPage',
  computed: {
    page() {
      // const module = this.$route.meta.byProduct.replace('{{product}}', this.ecosystem.product)
      return () => import(`@/pages/${this.pageProductPath}/${this.$route.meta.name}`)
    }
  }
}
</script>
